<template>
	<div>
		<preloader v-if="loading"></preloader>
		<table class="table table-borderless table-hover table-sm" v-if="bienes.length>0 && !loading">
			<thead class="border-bottom">
				<tr>
					<th class="text-center" v-if="form.bien">Endoso</th>
					<th class="text-center">Bien Asegurado</th>
					<th width="120px" class="text-center">Suma Asegurada</th>
					<th width="120px" class="text-center">Deducible 1</th>
					<th width="120px" class="text-center">Deducible 2</th>
					<th width="120px" class="text-center">Prima Neta</th>
					<th width="120px" class="text-center">Prima Total</th>
					<th class="text-center">Observaciones</th>
					<th width="120px"></th>
				</tr>
			</thead>
			<tbody v-for="(item, index) in bienes">
				<tr>
					<td v-if="form.bien == item.CODIGO_BIEN">
						<catalogo-endosos v-model="form.endoso" :poliza="item.CODIGO_POLIZA"></catalogo-endosos>
					</td>

					<td v-if="form.bien == item.CODIGO_BIEN">
						<input type="text" class="form-control form-control-sm" v-model="form.descripcion">
						<div v-if="errors && errors.descripcion" class="text-danger">
	                        {{ errors.descripcion[0] }}
	                    </div>
					</td>
					<td v-else>
						{{item.DESCRIPCION_BIEN}}
					</td>
					
					<td>
						<div v-if="form.bien == item.CODIGO_BIEN">
							<decimal type="text" class="form-control form-control-sm" v-model="form.sumaAsegurada" min="0"></decimal>
							<div v-if="errors && errors.suma_asegurada" class="text-danger">
		                        {{ errors.suma_asegurada[0] }}
		                    </div>
						</div>
						<div v-else class="text-right">
							{{money(item.SUMA_ASEGURADA, true)}}
						</div>
					</td>

					<td>
						<div v-if="form.bien == item.CODIGO_BIEN">
							<decimal type="text" class="form-control form-control-sm" v-model="form.deducible1" min="0"></decimal>
							<div v-if="errors && errors.deducible1" class="text-danger">
		                        {{ errors.deducible1[0] }}
		                    </div>
						</div>
						<div v-else class="text-right">
							{{money(item.DEDUCIBLE1, true)}}
						</div>
					</td>
					<td>
						<div v-if="form.bien == item.CODIGO_BIEN">
							<decimal type="text" class="form-control form-control-sm" v-model="form.deducible2" min="0"></decimal>
							<div v-if="errors && errors.deducible2" class="text-danger">
		                        {{ errors.deducible2[0] }}
		                    </div>
						</div>
						<div v-else class="text-right">
							{{money(item.DEDUCIBLE2, true)}}
						</div>
					</td>
					<td>
						<div v-if="form.bien == item.CODIGO_BIEN">
							<decimal type="text" class="form-control form-control-sm" v-model="form.primaNeta" min="0"></decimal>
							<div v-if="errors && errors.prima_neta" class="text-danger">
		                        {{ errors.prima_neta[0] }}
		                    </div>
						</div>
						<div v-else class="text-right">
							{{money(item.PRIMA_NETA, true)}}
						</div>
					</td>
					<td>
						<div v-if="form.bien == item.CODIGO_BIEN">
							<decimal type="text" class="form-control form-control-sm" v-model="form.primaTotal" min="0"></decimal>
							<div v-if="errors && errors.prima_total" class="text-danger">
		                        {{ errors.prima_total[0] }}
		                    </div>
						</div>
						<div v-else class="text-right">
							{{money(item.PRIMA_TOTAL, true)}}
						</div>
					</td>
					<td>
						<div v-if="form.bien == item.CODIGO_BIEN">
							<textarea type="text" class="form-control form-control-sm" v-model="form.observaciones" maxlength="255"></textarea>
							<div v-if="errors && errors.observaciones" class="text-danger">
		                        {{ errors.observaciones[0] }}
		                    </div>
						</div>
						<div v-else>
							{{item.OBSERVACIONES}}
						</div>
					</td>

					<td class="align-middle text-center">
						<div class="table-hover-options">
							<button type="button" v-on:click="saveBien" class="btn btn-sm btn-link text-muted" v-if="form.bien == item.CODIGO_BIEN  && !disabledValue" :disabled="form.loading">
								<i class="material-icons">save</i>
							</button>

							<button type="button" v-on:click="editBien(item)" class="btn btn-sm btn-link text-muted" v-if="form.bien != item.CODIGO_BIEN && roleUser() != 'V' && !disabledValue">
								<i class="material-icons">edit</i>
							</button>

							<button type="button" v-on:click="cancelBien" class="btn btn-sm btn-link text-muted text-danger" v-if="form.bien == item.CODIGO_BIEN && !disabledValue" :disabled="form.loading">
								<i class="material-icons">cancel</i>
							</button>

							<button type="button" v-on:click="deleteBien(item.CODIGO_BIEN)" class="btn btn-sm btn-link text-muted" v-if="form.bien != item.CODIGO_BIEN && roleUser() != 'V' && !disabledValue">
								<i class="material-icons">delete</i>
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-else class="text-center text-muted py-3">
			No se ha agregado ningún Bien Asegurado.
		</div>
	</div>
</template>
<script>
	export default {
		props: ['poliza', 'disabled'],

		data(){
			return {
				bienes: [],
				loading: false,
				form: {
					loading: false,
					bien: 0,
					poliza: 0,
					endoso: 0,
					descripcion: '',
					sumaAsegurada: 0,
					deducible1: 0,
					deducible2: 0,
					primaNeta: 0,
					primaTotal: 0,
					observaciones: ''
				},
				errors: {}
			}
		},

		mounted(){
			var vm = this;
			$.fn.getBienesDetalle = function () {
				vm.getBienes();
			};
		},

		created(){
			this.getBienes()
		},

		methods: {
			getBienes: function(){
				this.loading = true

				if (this.polizaId) {
					axios.get('api/polizas/'+this.polizaId+'/bienes')
					.then(response=>{
						this.bienes = response.data
						$('#badge-bienes').text(response.data.length);
					}).catch(error=>{
						console.log(error.response)
					}).then(() => {
						this.loading = false
					})
				}
			},

			deleteBien: function(id){
				axios.delete('api/bienes/'+id+'/delete')
				.then(response=>{
					this.getBienes()
					this.$toasted.show('El Bien ha sido Eliminado.');
				}).catch(error=>{
					this.$toasted.show('Error al eliminar Bien.');
					console.log(error.response)
				})
			},

			editBien: function(data){
				this.form.bien = data.CODIGO_BIEN
				this.form.poliza = data.CODIGO_POLIZA
				this.form.endoso = data.CODIGO_ENDOSO
				this.form.descripcion = data.DESCRIPCION_BIEN
				this.form.sumaAsegurada = data.SUMA_ASEGURADA
				this.form.deducible1 = data.DEDUCIBLE1
				this.form.deducible2 = data.DEDUCIBLE2
				this.form.primaNeta = data.PRIMA_NETA
				this.form.primaTotal = data.PRIMA_TOTAL
				this.form.observaciones = data.OBSERVACIONES
				this.errors = {}
			},

			saveBien: function(){
				this.form.loading = true
				this.errors = {}

				axios.put('api/bienes/'+this.form.bien, {
					endoso: this.form.endoso,
			        descripcion: this.form.descripcion,
			        suma_asegurada: this.form.sumaAsegurada,
			        prima_neta: this.form.primaNeta,
			        prima_total: this.form.primaTotal,
			        deducible1: this.form.deducible1,
			        deducible2: this.form.deducible2,
			        observaciones: this.form.observaciones
				})
				.then(response=>{
					this.getBienes()
					this.cancelBien()
					$('html').getDetallePoliza()
					$('html').getEndosos()
					this.$toasted.show('El Bien ha sido Actualizado.');
				}).catch(error=>{
					this.$toasted.show('Error al actualizar.');
					console.log(error.response.data)
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
				}).then(() => {
					this.form.loading = false
				})
			},

			cancelBien: function(){
				this.form.bien = ''
				this.form.poliza = ''
				this.form.endoso = ''
				this.form.descripcion = ''
				this.form.sumaAsegurada = ''
				this.form.deducible1 = ''
				this.form.deducible2 = ''
				this.form.primaNeta = ''
				this.form.primaTotal = ''
				this.form.observaciones = ''
			}
		},

		computed: {
			polizaId: function(){
				return this.poliza
			},

			disabledValue: function(){
				return this.disabled
			}
		},

		watch: {
			polizaId: function(val){
				this.getBienes()
			}
		}
	}
</script>